"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoNode = void 0;
var slate_1 = require("slate");
var isVideoNode = function (elem) {
    return slate_1.Element.isElement(elem) && elem.type === "video";
};
exports.isVideoNode = isVideoNode;
